import { useEffect, useState } from 'react';
import { isFilled } from '~/src/components/AdBanner/utils';
import useMutationObserver from './useMutationObserver';
import { useOnboardingServices } from '../components/CustomApp/OnboardingCustomApp';
import { ADS_EVENTS } from '../services/analytics/contants';

const OBSERVE_OPTIONS = { attributeFilter: ['data-ad-status'] };

const useObserveOnboardingBannerStatus = (placement: string, onStatusChange?: (el: HTMLModElement) => void) => {
  const { Analytics } = useOnboardingServices();
  const [bannerRef, setBannerRef] = useState<HTMLModElement | null>(null);

  useEffect(() => {
    if (bannerRef) {
      // on first render of banner, it can be already filled
      // MutationObserver watch for changes being made to the DOM tree
      const isBannerFilled = isFilled(bannerRef);
      if (isBannerFilled) {
        Analytics.sendEvent(ADS_EVENTS.showedBanner, { type: 'adsense', name: placement });
        onStatusChange?.(bannerRef);
      }
    }
  }, []);

  useMutationObserver(
    bannerRef,
    (mutations) => {
      mutations.forEach(({ target }) => {
        const isBannerFilled = isFilled(target as HTMLModElement);
        if (isBannerFilled) {
          Analytics.sendEvent(ADS_EVENTS.showedBanner, { type: 'adsense', name: placement });
        } else {
          Analytics.sendEvent(ADS_EVENTS.bannerFailed, { type: 'noAd', placement });
        }
        onStatusChange?.(target as HTMLModElement);
      });
    },
    OBSERVE_OPTIONS
  );

  return setBannerRef;
};

export default useObserveOnboardingBannerStatus;
